<template>
   <!-- HISTORY:
      10/14/20(B0.1): File was created.
   -->

   <div>
      <v-content class="px-0 pt-0 pb-0">
         <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
            <span>{{ this.snackbarMsg }}</span>
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
         </v-snackbar>

         <v-layout>
            <Menu
               :baseRoute="baseRoute"
               :mini-variant="miniVariant"
               @more-click="moreClicked"
            />
            <router-view 
               :debug="true"
               :is-actual-endpoint="true"
               @snackbar-event="setSnackbar"
            ></router-view>
         </v-layout>
      </v-content>
   </div>
</template>

<script>
import Menu from '../components/CsMenu.vue';
import { IamSettings } from '../models/iam-settings.js';

export default {
   components: {
      Menu
   },

   data() {
      return {
         baseRoute: "contact-service",
         snackbar: false,
         snackbarMsg: '',
         settings: new IamSettings()
      }
   },

   computed: {
      miniVariant() {
         return !this.settings.keepMenuExpanded;
      }
   },
   methods: {
      setSnackbar (msg) {
         this.snackbarMsg = msg;
         this.snackbar = true;
      },
      moreClicked() {
         this.settings.keepMenuExpanded = !this.settings.keepMenuExpanded;
         this.settings.save();
      }
   },
   created() {
      // if (this.$route.query.route) {
      //    if (this.$route.query.search)
      //       this.$router.push(`/${this.baseRoute}/${this.$route.query.route}?search=${this.$route.query.search}`);
      //    else
      //       this.$router.push(`/${this.baseRoute}/${this.$route.query.route}`);
      // } else
      //    this.$router.push(`/${this.baseRoute}/${this.settings.lastPageViewed}`);
   }
};
</script>
